// extracted by mini-css-extract-plugin
module.exports = {"container":"Sensor_container__1caVi","name":"Sensor_name__lnfah","external":"Sensor_external__uAd94","binIcon":"Sensor_binIcon__EBm9E"};